import React, { useState } from 'react';
import { View, TextInput, Text } from 'react-native';
import CountryPicker from 'react-native-country-picker-modal';

const { PhoneNumberUtil, PhoneNumberFormat, PhoneNumberType } = require('google-libphonenumber');
const phoneUtil = PhoneNumberUtil.getInstance();


const InternationalPhoneInput = (props) => {
    const [countryCode, setCountryCode] = useState('JP');
    const [callingCode, setCallingCode] = useState('81');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isValid, setIsValid] = useState(true);

    const validatePhone = (text, country) => {
        setPhoneNumber(text);
        props.setPhone(text);
        if (!text) {
            setIsValid(true); // Keep it neutral if empty
            return;
        }

        try {
            const numberProto = phoneUtil.parseAndKeepRawInput(text, country);
            const valid = phoneUtil.isValidNumber(numberProto);
            const type = phoneUtil.getNumberType(numberProto);

            const isMobile = type === PhoneNumberType.MOBILE ||
                type === PhoneNumberType.FIXED_LINE_OR_MOBILE;

            setIsValid(valid && isMobile);
            props.setValidPhone(valid && isMobile);
            props.setDialCode(callingCode);
        } catch (e) {
            setIsValid(false);
            props.setValidPhone(false);
            props.setDialCode(callingCode);
        }
    };

    return (
        <View className="w-full">
            {/* Input Container */}
            <View className="flex-row items-center">
                <CountryPicker
                    countryCode={countryCode}
                    withFilter
                    withFlag
                    withCallingCode
                    withAlphaFilter={false}
                    modalProps={{
                        ariaHideApp: false,
                    }}
                    renderFlagButton={({ onOpen }) => (
                        <View className="flex-row items-center mr-2 px-[15px] bg-[#F2F3F5] color-[#86909C] h-9 cursor-pointer" onStartShouldSetResponder={() => true} onResponderRelease={onOpen}>
                            <Text className="text-[#86909C] cursor-pointer">
                                +{callingCode}
                            </Text>
                        </View>
                    )}
                    onSelect={(country) => {
                        setCountryCode(country.cca2);
                        props.setDialCode(country.callingCode[0]);
                        setCallingCode(country.callingCode[0]);
                        validatePhone(phoneNumber, country.cca2);
                    }}
                />

                <TextInput
                    className="flex-1 w-full h-9 bg-[#F2F3F5] color-[#121212] px-4"
                    placeholder=""
                    placeholderTextColor="#9ca3af"
                    keyboardType="phone-pad"
                    value={phoneNumber}
                    onChangeText={(text) => validatePhone(text, countryCode)}
                />
            </View>

            {/* Error Message */}
            {/* {!isValid && (
                <Text className="text-red-600 text-xs mt-2 ml-1 font-semibold">
                    That doesn't look like a valid mobile number.
                </Text>
            )} */}

            {/* Debug/Success Info */}
            {/* {isValid && phoneNumber.length > 5 && (
                <Text className="text-green-600 text-xs mt-2 ml-1">
                    Ready to roll! Format: {callingCode} {phoneNumber}
                </Text>
            )} */}
        </View>
    );
};

export default InternationalPhoneInput;